import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../components/FormikControl/FormikControl';
import invoiceServices from '../invoiceServices';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';
import AwsImageInline from '../../../../../components/InlineEdit/AwsImageInline';
import moment from 'moment';



function InvoiceForm({data,callBack }) {

    const {AppAlert} = useAlert();
    const {masters} = useAppData();
    const {customerDD,companyDD} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {        
        companyId:"",
        customerId:"",
        invoiceNumber:"",
        orderNumber:"",
        waybillNumber:"",
        invoiceDate:moment().format(moment.HTML5_FMT.DATE),
        paymentDueDate:moment().format(moment.HTML5_FMT.DATE),
        declaration:"We declare that this invoice shows the actual price of the goods / services described and that all particulars are true and correct.",
        terms:"",
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            companyId:data.companyId,
            customerId:data.customerId,
            invoiceNumber:data.invoiceNumber,
            orderNumber:data.orderNumber,
            waybillNumber:data.waybillNumber,
            invoiceDate:data.invoiceDate?data.invoiceDate:moment().format(moment.HTML5_FMT.DATE),
            paymentDueDate:data.paymentDueDate?data.paymentDueDate:moment().format(moment.HTML5_FMT.DATE),
            declaration:data.declaration?data.declaration:"We declare that this invoice shows the actual price of the goods / services described and that all particulars are true and correct.",
            terms:data.terms,
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        companyId:Yup.string().required("Required"),
        customerId:Yup.string().required("Required"),
        invoiceNumber:Yup.string().required("Required"),
        invoiceDate:Yup.string().required("Required"),
        //declaration:Yup.string().required("Required"),
        //terms:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        invoiceServices.save(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            console.log(error);
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    {/*
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/> Edit Invoice
                    </IconButton>
                </Tooltip>
                */}
    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Generate New Invoice</button>
                </Tooltip>
            }
            {data &&
                
                <button className="btn btn-outline-primary me-2" onClick={updateData}>Edit Invoice Details</button>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Invoice"}</DialogTitle>
                                    <DialogContent>
                                            <div className="row p-3">
                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Select Company / Firm " name="companyId"  
                                                        options={companyDD} multiple={false} 
                                                    />
                                                </div>

                                                <div className='col-md-6 my-2'>
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Select Customer" name="customerId"  
                                                        options={customerDD} multiple={false} 
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Invoice Number" name="invoiceNumber" 
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Order Number" name="orderNumber" 
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Waybill No" name="waybillNumber" 
                                                    />
                                                </div>

                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="date" 
                                                        label="Invoice Date" name="invoiceDate" 
                                                    />
                                                </div>
                                                <div className="col-md-6  my-2" >
                                                    <FormikControl control="input" formik={formik} type="date" 
                                                        label="Payment Due Date" name="paymentDueDate" 
                                                    />
                                                </div>

                                                <hr className='my-3' />
                                                
                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" multiline={true}
                                                        label="Declaration" name="declaration"   
                                                    />
                                                </div>

                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" multiline={true}
                                                        label="Trems" name="terms"   
                                                    />
                                                </div>
                                            </div>
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik)  */}
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default InvoiceForm